import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Root from './scenes/Root';
import * as serviceWorker from './serviceWorker';


//this magically points to /public/index.html **
ReactDOM.render(<Root />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
